import { Controller } from "@hotwired/stimulus"
import { getViewportTier } from "../utils"

const SESSION_STORAGE_KEY = "rr_sid"

export default class extends Controller {
  static values = {
    session: String,
  }

  connect() {
    let token = this.sessionValue

    if (!token) {
      token = this.readFromSessionStorage()
      if (token) {
        this.sessionValue = token
      }
    }

    this.viewport = getViewportTier()

    this.beforeFetchHandler = this.beforeFetchHandler || this.beforeFetch.bind(this)
    document.addEventListener("turbo:before-fetch-request", this.beforeFetchHandler)
  }

  disconnect() {
    if (this.beforeFetchHandler) {
      document.removeEventListener("turbo:before-fetch-request", this.beforeFetchHandler)
    }
  }

  beforeFetch(event) {
    const { fetchOptions, url } = event.detail

    if (!fetchOptions.headers) {
      fetchOptions.headers = {}
    }

    const requestUrl = (url || fetchOptions.url || "").toString()

    if (requestUrl.includes("/logout")) {
      try {
        if (window.top !== window.self) {
          fetchOptions.headers["X-RR-Embed"] = "1"
        }
      } catch (err) {
        fetchOptions.headers["X-RR-Embed"] = "1"
      }

      this.sessionValue = ""
      try {
        window.sessionStorage.removeItem(SESSION_STORAGE_KEY)
      } catch (e) {
        // ignore
      }

      return
    }

    try {
      if (window.top !== window.self) {
        fetchOptions.headers["X-RR-Embed"] = "1"
      }
    } catch (err) {
      fetchOptions.headers["X-RR-Embed"] = "1"
    }

    if (!this.sessionValue) return

    fetchOptions.headers["X-Requested-With"] = "Turbo"
    fetchOptions.headers["X-Session"] = this.sessionValue
    fetchOptions.headers["X-RR-Device"] = this.viewport
  }

  readFromSessionStorage() {
    try {
      return window.sessionStorage.getItem(SESSION_STORAGE_KEY) || ""
    } catch (e) {
      return ""
    }
  }

  sessionValueChanged(newValue, oldValue) {
    if (!newValue) {
      try {
        window.sessionStorage.removeItem(SESSION_STORAGE_KEY)
      } catch (e) {
      }
      return
    }

    try {
      window.sessionStorage.setItem(SESSION_STORAGE_KEY, newValue)
    } catch (e) {
    }
  }
}
